export default __webpack_public_path__ + "static/media/hht2_direction_speakingbooster_02.5842f2c2.png";